import './AboutSection.css';
import React, { FC } from 'react';
import sadImage from '../../../assets/sad.webp';
import { Trans } from 'react-i18next';

export const AboutSection: FC = () => {
    return (
        <section className="about">
            <div className="about__container">
                <div className="about__content">
                    <p className="about__title">
                        <Trans
                            i18nKey="home.section1.title"
                            components={{ span: <span className="about__title--primary"></span> }}
                        />
                    </p>
                    <p className="about__description">
                        <Trans
                            i18nKey="home.section1.subtitle"
                            components={{ span: <span className="about__title--primary"></span> }}
                        />
                    </p>
                </div>
                <div className="about__image">
                    <img
                        src={sadImage}
                        alt="BalancePath"
                        loading="lazy"
                        fetchPriority="high"
                    />
                </div>
            </div>
        </section>
    );
};
